import { useState } from 'react';
import { useFormikContext } from 'formik';
import classnames from 'classnames';
import { useToggle } from '@/hooks/useToggle';
import { useGetFundraisingRecalculation } from '@/query/queries/fundraising/useGetFundraisingRecalculation';
import { useGetFundraisingStatus } from '@/query/queries/fundraising/useGetFundraisingStatus';
import { Tooltip } from '@/kit/Tooltip';
import { prettyFloatMoney } from '@/helpers/utils';
import IconEdit from '../../assets/icon_edit_black.svg';
import IconTooltip from '../../assets/icon_tooltip.svg?react';
import { GoalEditModal } from '../../components/GoalEditModal';
import IconArrow from './icon_arrrow.svg';
import s from './index.module.scss';
import { useTranslation } from 'react-i18next';

export const FundraisingCalculation = ({ manualTariffSet, companyId }) => {
  const [show, setShow] = useState(false);
  const [open, toggle] = useToggle();
  const { data: status } = useGetFundraisingStatus();
  const { values } = useFormikContext();
  const { t } = useTranslation('fundraising');
  const { data: result, isFetching } = useGetFundraisingRecalculation({
    tariff: manualTariffSet ? null : values.tariff_plan?.id,
    fpg: values.fpg?.id || null,
    flexibility: values.flexibility_option?.id || null,
    new_funds: values.new_funds,
    company_id: companyId,
  });

  const refinOnly = status?.max_new_funds === 0;

  return (
    <div className={s.wrapper}>
      <img
        src={IconArrow}
        alt="arrow"
        width={24}
        height={24}
        onClick={toggle}
        className={classnames(s.arrow, open && 'open')}
        style={{ cursor: 'pointer' }}
      />
      <div className={s.row} onClick={toggle} style={{ cursor: 'pointer' }}>
        <div className="f-body f-500">{t('fr_calculation.total_fundraising_goal')}</div>
        <div>{isFetching ? '...' : prettyFloatMoney(result?.goal_amount)}</div>
      </div>
      <div className={s.row} style={{ marginTop: '12px' }}>
        <div className={classnames(s.tooltip, 'f-label')}>
          {t('fr_calculation.net_proceeds_after_fees')}{' '}
          <Tooltip
            icon={<IconTooltip />}
            className={s.tooltip_icon}
            renderContent={() => (
              <div className={s.tooltip_text}>{t('fr_calculation.tooltip_text')}</div>
            )}
          />
        </div>
        <div className="f-label" style={{ color: 'var(--Grey-500, #908A94)' }}>
          {isFetching ? '...' : prettyFloatMoney(result?.net_amount)}
        </div>
      </div>
      <div className={classnames(s.dropdown, open && 'open')}>
        <div />
        {!refinOnly && (
          <div className={s.row}>
            <div>{t('fr_calculation.new_funds')}</div>
            <div className={s.edit}>
              <img
                src={IconEdit}
                alt="edit"
                width={24}
                height={24}
                onClick={() => setShow(!show)}
              />
              {prettyFloatMoney(values.new_funds)}
            </div>
          </div>
        )}

        {result?.refinancing.map(refinance => (
          <div key={refinance.name} className={s.row}>
            <div>{t('fr_calculation.refinance', { name: refinance.name })}</div>
            <div>{prettyFloatMoney(refinance.amount)}</div>
          </div>
        ))}
      </div>
      {show && <GoalEditModal onClose={() => setShow(false)} />}
    </div>
  );
};
